<template>
    <b-container fluid class="mt--7">
        <b-card no-body>
            <b-tabs pills card v-model="tabIndex" @activate-tab="tabActivated">
                <b-tab title="Data" active
                    ><b-card-text>
                        <b-card>
                            <b-card-header>
                                <b-button
                                    size="sm"
                                    class="float-right"
                                    @click="saveSettings"
                                    variant="light"
                                >
                                    <b-icon
                                        v-if="loading"
                                        icon="arrow-clockwise"
                                        animation="spin"
                                    ></b-icon>
                                    <span v-else> Save Settings</span>
                                </b-button>
                                Prepare Data
                            </b-card-header>
                            <b-card-body>
                                <b-card>
                                    <b-form-row>
                                        <b-col cols="3">Site</b-col>

                                        <b-col>
                                            <b-form-select
                                                id="input-location"
                                                v-model="formData.location_id"
                                                :options="locations"
                                                value-field="id"
                                                text-field="name"
                                            >
                                                <template #first>
                                                    <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                    >
                                                        Select Warehouse
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>

                                        <b-col>
                                            <b-form-select
                                                id="input-section"
                                                v-model="formData.section_id"
                                                :options="sections"
                                                value-field="id"
                                                text-field="name"
                                            >
                                                <template #first>
                                                    <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                    >
                                                        Select Section
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row>
                                        <b-col cols="3">From Date/Time</b-col>
                                        <b-col>
                                            <b-form-input
                                                id="input-date"
                                                v-model="formData.startDate"
                                                placeholder="Enter Date"
                                                type="date"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col>
                                            <b-form-input
                                                id="input-startTime"
                                                v-model="formData.startTime"
                                                placeholder="Start Time"
                                                type="time"
                                            ></b-form-input>
                                        </b-col>
                                    </b-form-row>

                                    <b-form-row>
                                        <b-col cols="3"> To Date/time </b-col>
                                        <b-col>
                                            <b-form-input
                                                id="input-date"
                                                v-model="formData.endDate"
                                                placeholder="Enter Date"
                                                type="date"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col>
                                            <b-form-input
                                                id="input-endTime"
                                                v-model="formData.endTime"
                                                placeholder="End Time"
                                                type="time"
                                            ></b-form-input>
                                        </b-col>
                                    </b-form-row>
                                </b-card>

                                <b-row no-gutters>
                                    <b-col>
                                        <b-card title="Bundled Items">
                                            <master-item-type-ahead
                                                key="majorItems"
                                                v-model="major_item_id"
                                                :is-bundled-only="true"
                                                :is-product-only="true"
                                                :item-type-id.sync="
                                                    order_item_type_id
                                                "
                                                :parent-searched-text.sync="
                                                    searchText
                                                "
                                            ></master-item-type-ahead>
                                            <b-table
                                                :fields="fields"
                                                striped
                                                hover
                                                responsive
                                                :items="bundledItems"
                                                :busy="loading"
                                            >
                                                <template #cell(id)="{ value }">
                                                    <b-button
                                                        variant="warning"
                                                        size="sm"
                                                        @click="
                                                            bundledItems.splice(
                                                                bundledItems.findIndex(
                                                                    x =>
                                                                        x.id ==
                                                                        value
                                                                ),
                                                                1
                                                            )
                                                        "
                                                        >Remove</b-button
                                                    >
                                                </template>
                                                <template #table-busy>
                                                    <div
                                                        class="text-center text-danger my-2"
                                                    >
                                                        <b-spinner
                                                            class="align-middle"
                                                        ></b-spinner>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </template>
                                            </b-table>
                                        </b-card>
                                    </b-col>
                                    <b-col>
                                        <b-card title="Secondary Items">
                                            <master-item-type-ahead
                                                key="minorItems"
                                                v-model="minor_item_id"
                                                :is-product-only="true"
                                                :item-type-id.sync="
                                                    order_item_type_id
                                                "
                                                :parent-searched-text.sync="
                                                    searchText2
                                                "
                                            ></master-item-type-ahead>
                                            <b-table
                                                :fields="fields"
                                                striped
                                                hover
                                                responsive
                                                :items="minorItems"
                                                :busy="loading"
                                            >
                                                <template #cell(id)="{ value }">
                                                    <b-button
                                                        variant="warning"
                                                        size="sm"
                                                        @click="
                                                            minorItems.splice(
                                                                minorItems.findIndex(
                                                                    x =>
                                                                        x.id ==
                                                                        value
                                                                ),
                                                                1
                                                            )
                                                        "
                                                        >Remove</b-button
                                                    >
                                                </template>
                                                <template #table-busy>
                                                    <div
                                                        class="text-center text-danger my-2"
                                                    >
                                                        <b-spinner
                                                            class="align-middle"
                                                        ></b-spinner>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </template>
                                            </b-table>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-card-text></b-tab
                >
                <b-tab title="Customisation"
                    ><b-card-text>
                        <usage-settings
                            :save-settings-counter="saveSettingsCounter"
                            :headings="headings"
                            :form-data="formData"
                            :bundled-list="bundledItems.map(x => x.id)"
                            :minor-list="minorItems.map(x => x.id)"
                            @updating-settings="updateSettings"
                            @set-loading-state="e => (loading = e)"
                        /> </b-card-text
                ></b-tab>
                <b-tab title="Report">
                    <b-card-body>
                        <display-usage
                            v-if="tabIndex == 2"
                            :vendors="vendors"
                            :minor-items="minorItems"
                            :opening-time="startDatetime"
                            :closing-time="endDateTime"
                            :headings="headings"
                            :settings="settings"
                            :parse-item="parseItem"
                            :section-id="formData.section_id"
                            :order-types="orderTypes"
                        />
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
import DisplayUsage from './DisplayUsage.vue'
import UsageSettings from './UsageSettings.vue'
import popupMixins from '@/mixins/popupMixins'

const dt = new Date()

const usageDate = `${dt.getFullYear()}-${
    (dt.getMonth() < 9 ? '0' : '') + (dt.getMonth() + 1)
}-${dt.getDate()}`
const startTime = '08:00:00'
const endTime = '17:00:00'

export default {
    components: { MasterItemTypeAhead, DisplayUsage, UsageSettings },
    mixins: [popupMixins],
    data() {
        return {
            tabIndex: 0,
            order_item_type_id: null,
            searchText: null,
            searchText2: null,
            settings: {},
            saveSettingsCounter: 0,

            formData: {
                location_id: null,
                section_id: null,
                startDate: usageDate,
                endDate: usageDate,
                startTime,
                endTime,
            },
            loading: false,
            major_item_id: null,
            minor_item_id: null,
            bundledItems: [],
            minorItems: [],
            fields: [
                {
                    key: 'id',
                    label: 'Action',
                },
                'name',

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: 'Vendor',
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) => item.selling_price,
                },
            ],
        }
    },

    computed: {
        headings() {
            return [
                'OpeningBundledCount',
                'OpeningUnbundledSubProductCount',
                'PurchasesPrincipalProduct',
                'PurchasesSubProduct',
                'SalesPrincipalProduct',
                'SalesSubProduct',
                'ReturnedUnbundledSubProductCount',
                'ClosingBundledCount',
                'ClosingUnbundledSubProductCount',
                'TotalUnbundledSubProductCount',
            ]
        },

        vendors() {
            const {
                formData: { section_id: sectionId },
                bundledItems,
                $set,
                parseItem,
            } = this

            if (!sectionId) return []

            bundledItems.sort((a, b) => a.size - b.size)
            const _vendors = bundledItems
                .filter(x => !!(x.vendor && x.vendor.id))
                .reduce((_vendors, m_item) => {
                    const newItem = parseItem(m_item, sectionId)
                    $set(
                        newItem,
                        'container',
                        parseItem(newItem.container, sectionId)
                    )
                    let vIdx = _vendors.findIndex(v => v.id == m_item.vendor.id)
                    if (vIdx < 0) {
                        const vendor = { ...m_item.vendor, items: [] }
                        _vendors = [..._vendors, vendor]
                        vIdx = _vendors.length - 1
                    }
                    _vendors[vIdx].items.push(newItem)
                    return _vendors
                }, [])

            _vendors.sort((a, b) => a.name.localeCompare(b.name))

            return _vendors
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            )
        },
        sections() {
            const { location_id } = this.formData
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },

        startDatetime() {
            const { startTime, startDate } = this.formData
            return this.convertTime(startDate, startTime)
        },
        endDateTime() {
            const { endTime, endDate } = this.formData
            return this.convertTime(endDate, endTime)
        },
        orderTypes() {
            const types = this.$store.state.orderType.items
            console.log('order types', types)
            return types
        },
    },

    watch: {
        major_item_id: function (id) {
            if (id) {
                this.major_item_id = null
                this.getMasterItem(id, 'bundledItems')
            }
        },
        minor_item_id: function (id) {
            if (id) {
                this.minor_item_id = null
                this.getMasterItem(id, 'minorItems')
            }
        },
        sections: {
            handler: function (val) {
                if (val && val.length) {
                    this.$set(this.formData, 'section_id', val[0].id)
                }
            },
            deep: true,
        },
    },

    created() {
        console.log('timezone', new Date().getTimezoneOffset())
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('users/fetchAll')
    },

    methods: {
        tabActivated(newTabIndex, oldTabIndex, event) {
            if (newTabIndex == 2) {
                try {
                    const {
                        startDatetime,
                        endDateTime,
                        bundledItems,
                        formData: { section_id },
                    } = this
                    if (bundledItems.length == 0)
                        throw new Error('No Bundled Items Selected!')
                    if (!section_id) throw new Error('Location Not Selected!')
                    if (startDatetime >= endDateTime)
                        throw new Error(
                            'Start Time must be before the End Time!'
                        )
                } catch (error) {
                    event.preventDefault()
                    this.doToast('Error', error.message, 'warning')
                }
            }
        },
        saveSettings() {
            this.saveSettingsCounter++
        },

        parseItem(item, sectionId) {
            const newItem = { ...item }

            let newSection = {}
            if (newItem.sections) {
                newSection =
                    item.sections.find(
                        x => x.location_section_id == sectionId
                    ) || {}
            }

            newItem.section = { ...newSection }
            this.$delete(newItem, 'sections')

            newItem.section.transactions = newItem.section.transactions || []

            newItem.section.transactions.forEach(x => {
                x.signature_data = null
                x.warehouse_signature_data = null
                return x
            })
            return newItem
        },

        async updateSettings(evt) {
            this.settings = { ...evt }
            let { formData, bundledList, minorList } = this.settings
            formData = formData || {}
            bundledList = bundledList || []
            minorList = minorList || []

            for (const key in formData) {
                this.$set(this.formData, key, formData[key])
            }

            await Promise.all(
                bundledList.map(id => this.getMasterItem(id, 'bundledItems'))
            )

            await Promise.all(
                minorList.map(id => this.getMasterItem(id, 'minorItems'))
            )

            this.$delete(this.settings, 'formData')
            this.$delete(this.settings, 'bundledList')
            this.$delete(this.settings, 'minorList')
        },

        convertTime(datePart, timePart) {
            if (!timePart) return null
            if (!datePart) return null
            let [year, month, day] = datePart.split('-')
            let [hour, minute] = timePart.split(':')
            const unixTime = new Date(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hour),
                parseInt(minute)
            ).getTime()
            return unixTime
        },

        async getMasterItem(id, type) {
            try {
                this.loading = true
                const item = await this.$store.dispatch(
                    'masterItem/fetchByIdFunction',
                    id
                )
                if (
                    this[type].length == 0 ||
                    !this[type].some(x => x.id == id)
                ) {
                    if (type === 'bundledItems' && item.container) {
                        const bundledItem = await this.$store.dispatch(
                            'masterItem/fetchByIdFunction',
                            item.container_id
                        )

                        item.container = bundledItem
                    }

                    const idx = this[type].findIndex(x => x.id == item.id)
                    this.$set(
                        this[type],
                        idx >= 0 ? idx : this[type].length,
                        item
                    )
                }
                this.searchText = null
                this.searchText2 = null
            } catch (err) {
                console.error('getMasterItem errior', err)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
